export const VIEWBOX_WIDTH = 1000
export const VIEWBOX_HEIGHT = 500
export const PADDING = { l: 60, r: 30, t: 30, b: 50 }

export const project = (w, h, idx, val, bounds, dataLength) => {
  const gx = PADDING.l
  const gy = PADDING.t
  const gw = w - PADDING.l - PADDING.r
  const gh = h - PADDING.t - PADDING.b

  const pointsCount = Math.max(1, dataLength - 1)
  const x = gx + (idx / pointsCount) * gw
  const range = bounds.maxY - bounds.minY || 1
  const y = gy + (1 - (val - bounds.minY) / range) * gh
  return { x, y }
}
